<template>
  <validation-observer ref="createCustomerForm">
    <b-form @submit.prevent="onSubmit">
      <b-row>
        <!-- Customer Type -->
        <b-col sm="6" lg="4">
          <b-form-group>
            <div class="d-flex form-group-label">
              <label for="type">{{ t('Type') }}</label>
              <span class="text-danger">*</span>
            </div>
            <validation-provider #default="{ errors }" :name="t('Type')" rules="required">
              <b-form-select
                id="type"
                v-model="values.type"
                :options="customerTypes"
                :state="errors.length > 0 ? false : null"
                :placeholder="t('Type')"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Name -->
        <b-col sm="6" lg="4">
          <b-form-group>
            <div class="d-flex form-group-label">
              <label for="name">{{ t('Name') }}</label>
              <span class="text-danger">*</span>
            </div>
            <validation-provider #default="{ errors }" :name="t('Name')" rules="required">
              <b-form-input
                id="name"
                v-model="values.name"
                :state="errors.length > 0 ? false : null"
                :placeholder="t('Name')"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Authorized Name Surname -->
        <b-col sm="6" lg="4">
          <b-form-group>
            <div class="d-flex form-group-label">
              <label for="authorized_name_surname">{{ t('Authorized Name Surname') }}</label>
              <span class="text-danger">*</span>
            </div>
            <validation-provider
              #default="{ errors }"
              :name="t('Authorized Name Surname')"
              rules="required"
            >
              <b-form-input
                id="authorized_name_surname"
                v-model="values.authorizedName"
                :state="errors.length > 0 ? false : null"
                :placeholder="t('Authorized Name Surname')"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Authorized No (Corporate only) -->
        <b-col v-if="isCorporate" sm="6" lg="4">
          <b-form-group>
            <div class="d-flex form-group-label">
              <label for="authorized_no">{{ t('Authorized No') }}</label>
              <span class="text-danger">*</span>
            </div>
            <validation-provider #default="{ errors }" :name="t('Authorized No')" rules="required">
              <b-form-input
                id="authorized_no"
                v-model="values.authorizedNo"
                :state="errors.length > 0 ? false : null"
                :placeholder="t('Authorized No')"
                type="number"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Phone -->
        <b-col sm="6" lg="4">
          <b-form-group>
            <div class="d-flex form-group-label">
              <label for="phone">{{ t('Phone') }}</label>
              <span class="text-danger">*</span>
            </div>
            <validation-provider #default="{ errors }" :name="t('Phone')" rules="required">
              <b-form-input
                id="phone"
                v-model="values.phone"
                :state="errors.length > 0 ? false : null"
                :placeholder="t('Phone')"
                type="number"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Tax Office (Corporate only) -->
        <b-col v-if="isCorporate" sm="6" lg="4">
          <b-form-group>
            <div class="d-flex form-group-label">
              <label for="tax_office">{{ t('Tax Office') }}</label>
              <span class="text-danger">*</span>
            </div>
            <validation-provider #default="{ errors }" :name="t('Tax Office')" rules="required">
              <b-form-input
                id="tax_office"
                v-model="values.tax_office"
                :state="errors.length > 0 ? false : null"
                :placeholder="t('Tax Office')"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Tax Number (Corporate only) -->
        <b-col v-if="isCorporate" sm="6" lg="4">
          <b-form-group>
            <div class="d-flex form-group-label">
              <label for="tax_no">{{ t('Tax Number') }}</label>
              <span class="text-danger">*</span>
            </div>
            <validation-provider #default="{ errors }" :name="t('Tax Number')" rules="required">
              <b-form-input
                id="tax_no"
                v-model="values.tax_no"
                :state="errors.length > 0 ? false : null"
                :placeholder="t('Tax Number')"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Mersis Number (Corporate only) -->
        <b-col v-if="isCorporate" sm="6" lg="4">
          <b-form-group>
            <div class="d-flex form-group-label">
              <label for="mersis_number">{{ t('Mersis Number') }}</label>
              <span class="text-danger">*</span>
            </div>
            <validation-provider #default="{ errors }" :name="t('Mersis Number')" rules="required">
              <b-form-input
                id="mersis_number"
                v-model="values.mersis_number"
                :state="errors.length > 0 ? false : null"
                :placeholder="t('Mersis Number')"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Trade Registry Number (Corporate only) -->
        <b-col v-if="isCorporate" sm="6" lg="4">
          <b-form-group>
            <div class="d-flex form-group-label">
              <label for="trade_registry_number">{{ t('Trade Registry Number') }}</label>
              <span class="text-danger">*</span>
            </div>
            <validation-provider
              #default="{ errors }"
              :name="t('Trade Registry Number')"
              rules="required"
            >
              <b-form-input
                id="trade_registry_number"
                v-model="values.trade_registry_number"
                :state="errors.length > 0 ? false : null"
                :placeholder="t('Trade Registry Number')"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Email -->
        <b-col sm="6" lg="4">
          <b-form-group>
            <div class="d-flex form-group-label">
              <label for="email">{{ t('Email') }}</label>
              <span class="text-danger">*</span>
            </div>
            <validation-provider #default="{ errors }" :name="t('Email')" rules="required|email">
              <b-form-input
                id="email"
                v-model="values.email"
                :state="errors.length > 0 ? false : null"
                :placeholder="t('Email')"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Address -->
        <b-col sm="6" lg="4">
          <b-form-group>
            <div class="d-flex form-group-label">
              <label for="address">{{ t('Address') }}</label>
              <span class="text-danger">*</span>
            </div>
            <validation-provider #default="{ errors }" :name="t('Address')" rules="required">
              <b-form-input
                id="address"
                v-model="values.address"
                :state="errors.length > 0 ? false : null"
                :placeholder="t('Address')"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Country -->
        <b-col sm="6" lg="4">
          <b-form-group>
            <div class="d-flex form-group-label">
              <label for="country">{{ t('Country') }}</label>
              <span class="text-danger">*</span>
            </div>
            <validation-provider #default="{ errors }" :name="t('Country')" rules="required">
              <v-select
                id="country"
                v-model="values.country"
                :options="countries"
                :placeholder="t('Make a Choice')"
                label="text"
                @input="onCountryChange"
              >
                <span slot="no-options">{{ t('No records found') }}</span>
              </v-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Postal Code -->
        <b-col sm="6" lg="4">
          <b-form-group>
            <div class="d-flex form-group-label">
              <label for="postalCode">{{ t('Postal Code') }}</label>
              <span class="text-danger">*</span>
            </div>
            <validation-provider #default="{ errors }" :name="t('Postal Code')" rules="required">
              <v-select
                id="postalCode"
                :disabled="!values.country || !values.country.value"
                v-model="values.postalCode"
                :options="customerPostalCodeOptions"
                :placeholder="t('Enter Postal Code')"
                label="combinedLabel"
                @search="handleCustomerPostalCodeSearch"
                @input="onPostalCodeSelected"
              >
                <span slot="no-options">{{ t('No records found') }}</span>
              </v-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- City -->
        <b-col sm="6" lg="4">
          <b-form-group>
            <div class="d-flex form-group-label">
              <label for="city">{{ t('City') }}</label>
              <span class="text-danger">*</span>
            </div>
            <validation-provider #default="{ errors }" :name="t('City')" rules="required">
              <v-select
                id="city"
                v-model="values.city"
                :options="cities"
                :placeholder="t('Make a Choice')"
                label="text"
                :disabled="!values.country || !values.country.value"
                @input="onCityChange"
              >
                <span slot="no-options">{{ t('No records found') }}</span>
              </v-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- District -->
        <b-col sm="6" lg="4">
          <b-form-group>
            <div class="d-flex form-group-label">
              <label for="state">{{ t('District') }}</label>
              <span class="text-danger">*</span>
            </div>
            <validation-provider #default="{ errors }" :name="t('District')" rules="required">
              <v-select
                id="state"
                v-model="values.state"
                :options="districts"
                :placeholder="t('Make a Choice')"
                label="text"
                :disabled="!values.city || !values.city.value"
                @input="onStateChange"
              >
                <span slot="no-options">{{ t('No records found') }}</span>
              </v-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Company Type -->
        <b-col sm="6" lg="4">
          <b-form-group>
            <div class="d-flex form-group-label">
              <label for="companyType">{{ t('Company Type') }}</label>
              <span class="text-danger">*</span>
            </div>
            <validation-provider #default="{ errors }" :name="t('Company Type')" rules="required">
              <b-form-select
                id="companyType"
                v-model="values.companyType"
                :options="[{ text: t('Make a Choice'), value: '' }].concat(companyTypes)"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Package -->
        <b-col sm="6" lg="4">
          <b-form-group>
            <div class="d-flex form-group-label">
              <label for="package_id">{{ t('Package') }}</label>
              <span class="text-danger">*</span>
            </div>
            <validation-provider #default="{ errors }" :name="t('Package')" rules="required">
              <b-form-select
                id="package_id"
                v-model="values.package_id"
                :options="[{ text: t('Make a Choice'), value: '' }].concat(packageOptions)"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Payment Type -->
        <b-col sm="6" lg="4">
          <b-form-group>
            <div class="d-flex form-group-label">
              <label for="paymentType">{{ t('Payment Type') }}</label>
              <span class="text-danger">*</span>
            </div>
            <validation-provider #default="{ errors }" :name="t('Payment Type')" rules="required">
              <b-form-select
                id="paymentType"
                v-model="values.paymentType"
                :options="
                  [{ text: t('Make a Choice'), value: '' }].concat(customerPaymentTypeOptions)
                "
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Status -->
        <b-col sm="6" lg="4">
          <b-form-group>
            <div class="d-flex form-group-label">
              <label for="status">{{ t('Status') }}</label>
              <span class="text-danger">*</span>
            </div>
            <validation-provider #default="{ errors }" :name="t('Status')" rules="required">
              <b-form-select id="status" v-model="values.status" :options="customerStatusTypes" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- Submit -->
        <b-col cols="12">
          <b-button variant="primary" type="submit" class="mt-1 d-flex align-items-center">
            {{ t('Create Customer') }}
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import { BRow, BCol, BForm, BFormGroup, BFormInput, BFormSelect, BButton } from 'bootstrap-vue';
import vSelect from 'vue-select';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import useService from '@/auth/service/useService';
import { helper } from '@core/mixins/helper.js';

export default {
  name: 'CreateCustomerForm',
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    vSelect,
    ValidationObserver,
    ValidationProvider
  },
  mixins: [helper],
  emits: ['submit'],
  data() {
    return {
      values: {
        type: 2,
        name: '',
        authorizedName: '',
        authorizedNo: '',
        phone: '',
        company_fixed_phone: '',
        tax_office: '',
        tax_no: '',
        mersis_number: '',
        trade_registry_number: '',
        email: '',
        address: '',
        country: '',
        city: '',
        state: '',
        postalCode: '',
        companyType: '',
        package_id: '',
        paymentType: '',
        status: 1
      },
      countries: [],
      cities: [],
      districts: [],
      minimumPostalCodeLength: 3,
      filteredPostalCodes: [],
      packageOptions: [],
      customerStatusTypes: [],
      customerTypes: [],
      companyTypes: [],
      customerPaymentTypeOptions: []
    };
  },
  computed: {
    isCorporate() {
      return parseInt(this.values.type) === 2;
    },
    customerPostalCodeOptions() {
      return this.filteredPostalCodes.map(code => ({
        value: code.zipcode,
        combinedLabel: `${code.zipcode} - ${code.place}`,
        state: code.state,
        city: code.city
      }));
    }
  },
  async created() {
    await Promise.all([
      useService.getCustomerStatusTypes().then(response => {
        this.customerStatusTypes =
          response.data.map(i => ({
            text: i.info,
            value: i.value
          })) || [];
      }),
      useService.getCustomerTypes().then(response => {
        this.customerTypes =
          response.data.map(i => ({
            text: i.info,
            value: i.value
          })) || [];
      }),
      this.getCountries(),
      this.getCustomerPaymentType().then(response => {
        this.customerPaymentTypeOptions = response;
      }),
      this.getPackages().then(response => {
        this.packageOptions = response.map(x => ({
          text: x.title,
          value: x.id
        }));
      }),
      this.getCompanyTypes()
    ]);
  },
  methods: {
    onSubmit() {
      this.$refs.createCustomerForm.validate().then(success => {
        if (!success) return;

        const basePayload = {
          name: this.values.name,
          authorized_name: this.values.authorizedName,
          authorized_no: this.values.authorizedNo,
          phone: this.values.phone,
          email: this.values.email,
          payment_type: parseInt(this.values.paymentType),
          status: this.values.status,
          package_id: this.values.package_id,
          type: parseInt(this.values.type),
          address: this.values.address
        };

        let payload = {
          ...basePayload,
          country: this.values.country?.value || '',
          city: this.values.city?.value || '',
          state: this.values.state?.value || '',
          postal_code:
            typeof this.values.postalCode === 'object'
              ? this.values.postalCode.value
              : this.values.postalCode,
          company_type: parseInt(this.values.companyType)
        };

        if (this.isCorporate) {
          payload = {
            ...payload,
            tax_office: this.values.tax_office,
            tax_no: this.values.tax_no,
            mersis_number: this.values.mersis_number,
            trade_registry_number: this.values.trade_registry_number
          };
        }

        this.$emit('submit', payload);
      });
    },
    async onPostalCodeSelected(selected) {
      try {
        if (!selected || !this.values.country || !this.values.country.value) return;
        const countryId = this.values.country.value;
        // Ensure cities are loaded for current country
        if (!this.cities || this.cities.length === 0) {
          await this.getCities(countryId);
        }
        // Match city by name
        if (selected.city) {
          const matchedCity =
            this.cities.find(
              c => (c.text || '').toLowerCase() === (selected.city || '').toLowerCase()
            ) || null;
          if (matchedCity) {
            this.values.city = matchedCity;
            // Load districts for matched city
            await this.getDistricts(countryId, matchedCity.value);
            // Match district/state by name
            if (selected.state) {
              const matchedDistrict =
                this.districts.find(
                  d => (d.text || '').toLowerCase() === (selected.state || '').toLowerCase()
                ) || null;
              if (matchedDistrict) {
                this.values.state = matchedDistrict;
              }
            }
          }
        }
      } catch (e) {
        // swallow silently; optional autofill
      }
    },
    async getCountries() {
      const response = await useService.getCountryList();
      this.countries = response.data.map(country => ({
        text: country.name,
        value: country.id,
        iso2: country.iso2
      }));
    },
    async getCities(countryId) {
      const response = await useService.getStateList(countryId);
      this.cities = response.data.map(city => ({
        text: city.name,
        value: city.id
      }));
    },
    async getDistricts(countryId, cityId) {
      const response = await useService.getCityList(countryId, cityId);
      this.districts = response.data.map(district => ({
        text: district.name,
        value: district.id
      }));
    },
    onCountryChange(country) {
      if (country && country.value) {
        this.values.city = '';
        this.values.state = '';
        this.values.postalCode = '';
        this.filteredPostalCodes = [];
        this.cities = [];
        this.districts = [];
        this.getCities(country.value);
      }
    },
    onCityChange(city) {
      if (city && city.value) {
        const countryId = this.values.country?.value;
        if (!countryId) return;
        this.getDistricts(countryId, city.value);
        this.values.state = '';
        this.districts = [];
        // Clear postal code until district selected
        this.values.postalCode = '';
        this.filteredPostalCodes = [];
      }
    },
    async onStateChange(state) {
      try {
        if (!state || !state.value) return;
        await this.loadPostalCodesForSelectedArea();
      } catch (e) {
        // ignore
      }
    },
    async loadPostalCodesForSelectedArea() {
      const country = this.values.country;
      const city = this.values.city;
      const district = this.values.state;
      if (!country || !country.iso2 || !city || !city.text) return;
      // Fetch a broader list by country_code, then filter client-side by city/district
      const params = {
        page: 1,
        limit: 500,
        country_code: country.iso2,
        zipcode: ''
      };
      const response = await useService.getAllPostalCodes(params);
      const list = (response && response.data) || [];
      const cityName = (city.text || '').toLowerCase();
      const districtName = (district?.text || '').toLowerCase();
      const filtered = list.filter(code => {
        const codeCity = (code.province || code.city || '').toLowerCase();
        const codeState = (code.state || '').toLowerCase();
        const cityMatch = cityName ? codeCity.includes(cityName) : true;
        const stateMatch = districtName ? codeState.includes(districtName) : true;
        return cityMatch && stateMatch;
      });
      this.filteredPostalCodes = filtered.map(code => ({
        place: code.place,
        zipcode: code.zipcode,
        state: code.state,
        city: code.province || code.city
      }));
      // Auto select first postal code if available
      if (this.filteredPostalCodes.length > 0) {
        const first = this.filteredPostalCodes[0];
        this.values.postalCode = {
          value: first.zipcode,
          combinedLabel: `${first.zipcode} - ${first.place}`,
          state: first.state,
          city: first.city
        };
      }
    },
    handleCustomerPostalCodeSearch(postalCode) {
      if (!this.values.country || !this.values.country.iso2) return;
      if (postalCode && postalCode.length >= this.minimumPostalCodeLength) {
        const data = {
          country_code: this.values.country.iso2,
          zipcode: postalCode
        };

        useService.autoPostalCodes(data).then(response => {
          const list = response.data || [];
          const filtered = list.filter(code => code.zipcode && code.zipcode.includes(postalCode));
          this.filteredPostalCodes = filtered.map(code => ({
            place: code.place,
            zipcode: code.zipcode,
            state: code.state,
            city: code.province || code.city
          }));
        });
      }
    },
    async getCompanyTypes() {
      const response = await useService.constantService.getCompanyType();
      this.companyTypes = response.data.map(type => ({
        text: type.info,
        value: type.value
      }));
    },
    async getCustomerPaymentType() {
      const response = await useService.getCustomerPaymentType();
      return (response.data || []).map(i => ({
        text: i.info,
        value: i.value
      }));
    },
    async getPackages() {
      const response = await useService.packageService.getPackages();
      return response.data || [];
    }
  },
  setup() {
    const { t } = useI18nUtils();
    return { t };
  }
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
